module.exports = __webpack_public_path__ + "static/media/icons-ic-callback-status.2a3080b2.svg";